export const IMAGE_MODAL_V2_BOTTOM_SURFACE = {
    PRIMARY_TOOLBAR: 'primaryToolbar',
    SECONDARY_TOOLBAR: 'secondaryToolbar',
    FILE_TRANSFER_STATUS: 'fileTransferStatus',
    MODAL_OPERATION_STATUS: 'modalOperationStatus',
} as const;

export type ImageModalV2BottomSurface =
    (typeof IMAGE_MODAL_V2_BOTTOM_SURFACE)[keyof typeof IMAGE_MODAL_V2_BOTTOM_SURFACE];

/** Choose the single bottom surface visible in the modal, in explicit product-priority order. */
export const getImageModalV2BottomSurface = ({
    hasModalOperation,
    hasFileTransfer,
    wantsSecondaryToolbar,
}: {
    hasModalOperation: boolean;
    hasFileTransfer: boolean;
    wantsSecondaryToolbar: boolean;
}): ImageModalV2BottomSurface => {
    if (hasModalOperation) return IMAGE_MODAL_V2_BOTTOM_SURFACE.MODAL_OPERATION_STATUS;
    if (hasFileTransfer) return IMAGE_MODAL_V2_BOTTOM_SURFACE.FILE_TRANSFER_STATUS;
    if (wantsSecondaryToolbar) return IMAGE_MODAL_V2_BOTTOM_SURFACE.SECONDARY_TOOLBAR;
    return IMAGE_MODAL_V2_BOTTOM_SURFACE.PRIMARY_TOOLBAR;
};
